module.exports = __webpack_public_path__ + "img/0Q3A3733_L_BlackMatted_MockedUp.6f23b620.jpg";